import { atom } from 'jotai';

const TOKEN_TTL_MS = 15 * 60 * 1000;

interface CachedSemaphorToken {
  accessToken: string;
  refreshToken: string;
  dashboardId: string;
  expiresAt: number;
}

export const $semaphorToken = atom<CachedSemaphorToken | null>(null);

export const $semaphorTokenValid = atom((get) => {
  const cached = get($semaphorToken);
  if (!cached) return false;
  return Date.now() < cached.expiresAt;
});

export const TOKEN_TTL = TOKEN_TTL_MS;
